import { makeStyles } from '@material-ui/core/styles'
import { themeCommon } from '../../theme'

const useStyles = makeStyles((theme) => ({
    tooltip: {
        background: '#FFFFFF',
        border: '1px solid #ADADAD',
        borderRadius: '5px',
        padding: '10px 5px',
    },
    rootGridContentContainer: {
        marginTop: '10px',
    },
    rootTitle: {
        fontFamily: themeCommon.RobotoBold,
    },

    // sun-editor // se-video-container
    customLayoutVideo: {
        '& .sun-editor': {
            '& .se-container':{
                '& .se-component.se-video-container': {
                    '& figure': {
                        width: '100% !important',
                        height: '500px !important',
                        [theme.breakpoints.down('md')]: {
                            height: '400px !important',
                        },
                        [theme.breakpoints.down('sm')]: {
                            height: '300px !important',
                        },
                    }
                }
            }
        }
    }
}), {
    name: 'LCDetailHeadContainer',
    index: 1,
})

export default useStyles